











import gql from 'graphql-tag'
import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppRouterLink from '@/components/AppRouterLink.vue'
import { Common } from '@/mixins'

@Component({
  components: {
    AppRouterLink
  },
  apollo: {
    item: {
      query: gql`query itemAtItemListItem($itemId: ID!) {
        item(itemId: $itemId) {
          id
          name
          medias {
            id
            path
          }
          seller {
            id
            shop {
              id
              shoppingMallName
            }
          }
        }
      }`,
      variables () { return { itemId: this.itemId } }
    }
  }
})
export default class extends Mixins(Common) {
  @Prop(String) readonly itemId!: string
  item = null
}
